
/* =================================================================================
    CONFIGURAȚIE SUPER AI PENTRU TOM GO - v. GENIU (Bugs Fixed)
    Data ultimei actualizări: 25 Iulie 2025
    ================================================================================= */

// --- ATENȚIE: Nu expune cheia API în codul de front-end pe un site live! ---
// Folosește o funcție serverless (ex: Cloudflare Worker, Vercel Function) ca proxy.
/*const proxyEndpoint = "https://nextjs-boilerplate-silk-five-62.vercel.app/api/openai-proxy"; // ✅ folosește proxy

// Dacă folosești un proxy, poți lăsa cheia goală aici, proxy-ul o va adăuga
// Daca nu folosesti un proxy, va trebui sa adaugi cheia aici
const openaiApiKey = "";

const siteUrl = 'https://www.tomgo.ro';
const chatKey = 'tomgo-ai-history-v8-genius'; // Versiune nouă pentru a reseta istoricul
const historyTtl = 24 * 60 * 60 * 1000; // 24 de ore
const PRODUCTS_CACHE_KEY = 'tg_products_cache_v2'; // { etag, ts, products }
const PRODUCTS_TTL_MS = 60 * 60 * 1000; // 1h
const productsEndpoint = 'https://nextjs-boilerplate-silk-five-62.vercel.app/api/products-full';

// =================================================================================
// VARIABILE GLOBALE
// =================================================================================

let products = [];
let chatHistory = [];
let currentCart = null; // Stochează contextul coșului de cumpărături
let autoOpenTimer = null;
let userCloseCount = 0;
const autoOpenSessionKey = 'aiChatAutoOpenSessionStarted';



const DO_NOT_AUTO_OPEN_KEY = 'aiChatDoNotAutoOpen_v1'; // blochează auto-open până la redeschidere manuală

function isParked() {
  try { return localStorage.getItem(DO_NOT_AUTO_OPEN_KEY) === '1'; }
  catch { return false; }
}
function setParked(val) {
  const bubble = document.getElementById('ai-bubble-container');
  if (val) {
    localStorage.setItem(DO_NOT_AUTO_OPEN_KEY, '1');
    if (bubble) bubble.classList.add('parked');
  } else {
    localStorage.removeItem(DO_NOT_AUTO_OPEN_KEY);
    if (bubble) bubble.classList.remove('parked');
  }
}

// =================================================================================
// INIȚIALIZARE
// =================================================================================

document.addEventListener('DOMContentLoaded', () => {
    if (!proxyEndpoint && !openaiApiKey) {
        console.error("ATENȚIE: proxyEndpoint sau openaiApiKey trebuie setat. Asistentul AI nu va funcționa.");
    }
    injectCyberneticStyles();
    loadProducts().then(() => {
        createCyberneticChatBubble();
        // ✔ Ajustare safe-area imediat ce există UI-ul
        applyMobileSafeArea();
        // ✔ Listeners pentru schimbări de viewport / tastatură
        attachSafeAreaListeners();

        restoreHistory();
        handleProactiveTriggers();

        if (!isParked() && !sessionStorage.getItem(autoOpenSessionKey)) {
    console.log("Prima vizită în sesiune. Se programează deschiderea automată a chat-ului.");
    sessionStorage.setItem(autoOpenSessionKey, 'true');
    autoOpenTimer = setTimeout(() => openChat(), 15000);
}
    });
});

// =================================================================================
// FUNCȚIE: Efect de scriere (typewriter) pentru titlu
// =================================================================================
function typeTitleOnce(titleText = "Asistent AI TOM GO", speed = 35){
  const el = document.getElementById("ai-title");
  if(!el || el.dataset.typed === "1") return; // rulează o singură dată / sesiune UI
  el.textContent = "";
  el.dataset.typed = "1";

  const caret = document.createElement("span");
  caret.className = "ai-caret";
  caret.textContent = "|";
  el.after(caret);

  let i = 0;
  const timer = setInterval(() => {
    el.textContent += titleText[i] ?? "";
    i++;
    if(i >= titleText.length){
      clearInterval(timer);
      caret.remove();
    }
  }, speed);
}

// Hook: rulează când se apelează openChat() (dacă există deja în proiect)
const _openChatOrig = typeof window.openChat === "function" ? window.openChat : null;
window.openChat = function(...args){
  const res = _openChatOrig ? _openChatOrig.apply(this, args) : undefined;
  setTimeout(() => typeTitleOnce("Asistent AI TOM GO", 35), 100);
  return res;
};

// =================================================================================
/* STILURI CSS (CYBERNETIC SYNAPSE + titlu luxury) */
// =================================================================================

function injectCyberneticStyles() {
    // (Opțional) Injectează meta viewport dacă lipsește
    if (!document.querySelector('meta[name="viewport"]')) {
        const m = document.createElement('meta');
        m.name = 'viewport';
        m.content = 'width=device-width, initial-scale=1, maximum-scale=1';
        document.head.appendChild(m);
    }

    const style = document.createElement('style');
    style.innerHTML = `
    /* --- Tema "Cybernetic Synapse" - Sticlă, Neon și Animații --- */
    @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=Orbitron:wght@700&display=swap');

    :root {
        /* Culori Cybernetic */
        --cyber-bg-dark: #0A0F1A;
        --cyber-bg-medium: rgba(15, 20, 35, 0.85);
        --cyber-glass-bg: rgba(25, 30, 50, 0.6);
        --cyber-card-bg: rgba(25, 30, 50, 0.9);
        --cyber-border-color: rgba(0, 255, 255, 0.2);
        --cyber-border-accent: rgba(0, 255, 255, 0.5);
        --cyber-text-primary: #E0F7FA;
        --cyber-text-secondary: #88AACC;
        --cyber-text-accent: #00FFFF;
        --cyber-neon-glow: 0 0 8px rgba(0, 255, 255, 0.6), 0 0 16px rgba(0, 255, 255, 0.4);
        --cyber-shadow-hover: 0 4px 20px rgba(0, 255, 255, 0.2);
        --cyber-button-glow: 0 0 12px rgba(0, 255, 255, 0.8);
        --cyber-scrollbar-track: rgba(0, 255, 255, 0.05);
        --cyber-scrollbar-thumb: rgba(0, 255, 255, 0.3);
        --cyber-scrollbar-thumb-hover: rgba(0, 255, 255, 0.5);
        --cyber-user-bubble-bg: #2B3A5A;
        --cyber-bot-bubble-bg: #1A253A;
        --cyber-success-color: #27F47F;
        --cyber-success-bg: rgba(39, 244, 127, 0.2);
    }

    /* ── Scrollbar modern (doar pentru chat) ───────────────────────── */
    #ai-chat-content::-webkit-scrollbar { width: 8px; }
    #ai-chat-content::-webkit-scrollbar-track { background: var(--cyber-scrollbar-track); }
    #ai-chat-content::-webkit-scrollbar-thumb {
        background-color: var(--cyber-scrollbar-thumb);
        border-radius: 4px;
        border: 1px solid var(--cyber-scrollbar-track);
    }
    #ai-chat-content::-webkit-scrollbar-thumb:hover { background-color: var(--cyber-scrollbar-thumb-hover); }

    /* ── Animații globale ───────────────────────── */
    @keyframes cyber-fadeIn { from{opacity:0;transform:translateY(20px);} to{opacity:1;transform:translateY(0);} }
    @keyframes cyber-pulse-glow { 0%,100%{box-shadow:var(--cyber-neon-glow);} 50%{box-shadow:0 0 4px rgba(0,255,255,0.4), 0 0 8px rgba(0,255,255,0.2);} }
    @keyframes cyber-bg-pulse { 0%,100% {background-position: 0% 50%;} 50% {background-position: 100% 50%;} }
    @keyframes cyber-reveal { from { opacity: 0; } to { opacity: 1; } }
    @keyframes aiBlink { 50% { opacity: 0; } }

    /* ── Stil „luxury” pentru titlu + cursor ───────────────────────── */
    .ai-title{
      display:inline-block;
      font-family:"Playfair Display", ui-serif, Georgia, serif;
      font-weight:700;
      letter-spacing:.2px;
      line-height:1.2;
      background:linear-gradient(135deg,#CBA052 0%,#8B5E1A 40%,#F1D08A 70%,#7A5520 100%);
      -webkit-background-clip:text;
      background-clip:text;
      color:transparent;
      text-shadow:0 0 .01px rgba(0,0,0,0.2);
      white-space:pre; /* păstrează spațiile/numele exact */
    }
    .ai-caret{
      display:inline-block;
      margin-left:2px;
      font-weight:700;
      animation: aiBlink 1s step-end infinite;
      color: var(--cyber-text-accent);
    }
    
    /* Buton + container */
    #ai-bubble-container {
        position: fixed; right: 20px; bottom: 20px; z-index: 9999999;
        transition: all .5s cubic-bezier(.25, .8, .25, 1);
    }
    #ai-invite-label {
        background: var(--cyber-bg-medium); backdrop-filter: blur(10px);
        color: var(--cyber-text-primary); font-weight: 600; font-size: 11px;
        padding: 8px 16px; border-radius: 20px; box-shadow: 0 4px 15px rgba(0,0,0,0.4);
        transition: all .4s ease; margin-bottom: 12px;
        border: 1px solid var(--cyber-border-color); user-select: none;
        opacity: 0; animation: cyber-fadeIn .8s ease-out .5s forwards;
    }
    #ai-ai-btn {
        width: 60px; height: 60px; border-radius: 50%;
        background: var(--cyber-bg-medium);
        cursor: pointer; display: flex; align-items: center; justify-content: center;
        position: relative; transition: all .4s cubic-bezier(.25, .8, .25, 1);
        border: 2px solid var(--cyber-border-accent);
        animation: cyber-pulse-glow 2s infinite ease-in-out;
        box-shadow: var(--cyber-neon-glow);
    }
    #ai-ai-btn:hover { transform: scale(1.1); }
    .ai-icon { width: 30px; height: 30px; color: var(--cyber-text-accent); }

    /* Fereastra chat */
    #ai-chatbox {
        position: fixed; right: 20px; bottom: 80px;
        width: 380px; max-width: calc(100vw - 40px); max-height: 80vh;
        background: var(--cyber-glass-bg); backdrop-filter: blur(18px);
        border-radius: 20px; border: 1px solid var(--cyber-border-color);
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);
        display: flex; flex-direction: column; overflow: hidden;
        transform: scale(0.9) translateY(20px); opacity: 0; pointer-events: none;
        transition: all .6s cubic-bezier(.25, .8, .25, 1);
        z-index: 999999; transform-origin: bottom right;
    }
    #ai-chatbox.is-open { transform: scale(1) translateY(0); opacity: 1; pointer-events: auto; }

    /* Header */
    #ai-chatbox #ai-chat-header {
        padding: 16px; border-bottom: 1px solid var(--cyber-border-color);
        display: flex; justify-content: space-between; align-items: center;
        background: var(--cyber-card-bg);
        border-top-left-radius: 20px; border-top-right-radius: 20px;
    }
    #ai-chatbox #ai-chat-header > span {
        font-family: 'Orbitron', sans-serif;
        font-weight: 700;
        font-size: 18px;
        color: var(--cyber-text-accent);
        text-shadow: var(--cyber-neon-glow);
    }
    #ai-chatbox #ai-close { background: transparent; border: none; cursor: pointer; padding: 6px; color: var(--cyber-text-secondary); transition: .3s; border-radius: 50%; }
    #ai-chatbox #ai-close:hover { color: var(--cyber-text-primary); background: rgba(0, 255, 255, 0.1); }
    #ai-chatbox #ai-close svg { width: 16px; height: 16px; display: block; }

    /* Mobil */
    @media (max-width: 768px) {
        #ai-chatbox {
            bottom: 0; right: 0; width: 100%; height: calc(100vh - (16px + env(safe-area-inset-top, 0px)));
            border-radius: 20px 20px 0 0;
            transform: translateY(100%);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
            transform-origin: bottom center;
        }
        #ai-chatbox.is-open { transform: translateY(0); }
        #ai-chatbox #ai-chat-footer { border-radius: 0; }
    }
    
    /* Conținut & bule */
    #ai-chatbox #ai-chat-content { flex: 1; overflow-y: auto; padding: 16px; background: var(--cyber-bg-dark); }
    #ai-chatbox .ai-msg { margin-bottom: 10px; max-width: 85%; line-height: 1.4; word-wrap: break-word; transition: .5s; font-size: 13px; }
    #ai-chatbox .ai-bot {
        background: var(--cyber-bot-bubble-bg); color: var(--cyber-text-primary);
        padding: 12px 18px; border-radius: 18px 18px 18px 6px;
        float: left; clear: both; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        border: 1px solid rgba(0, 255, 255, 0.1);
    }
    #ai-chatbox .ai-user {
        background: var(--cyber-user-bubble-bg); color: var(--cyber-text-primary);
        padding: 12px 18px; border-radius: 18px 18px 6px 18px;
        float: right; clear: both; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        border: 1px solid rgba(0, 255, 255, 0.1);
    }
    
    /* Animație de tiparire futuristă */
    #ai-chatbox .ai-bot-typing {
        background: var(--cyber-bot-bubble-bg);
        padding: 12px 18px;
        border-radius: 18px 18px 18px 6px;
        float: left;
        clear: both;
        color: var(--cyber-text-secondary);
        font-size: 13px;
        min-width: 80px;
        overflow: hidden;
        border: 1px solid rgba(0, 255, 255, 0.1);
    }
    
    /* Footer */
    #ai-chatbox #ai-chat-footer {
        padding: 12px; border-top: 1px solid var(--cyber-border-color);
        display: flex; align-items: center; gap: 8px; background: var(--cyber-card-bg);
        border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;
    }
    #ai-chatbox #ai-chat-input {
        flex: 1; background: var(--cyber-bg-dark); border: 1px solid var(--cyber-border-color); border-radius: 20px;
        outline: 0; color: var(--cyber-text-primary); padding: 12px 16px; transition: .3s; font-size: 14px;
    }
    #ai-chatbox #ai-chat-input:focus { border-color: var(--cyber-text-accent); box-shadow: var(--cyber-neon-glow); }
    #ai-chatbox #ai-chat-input::placeholder { color: var(--cyber-text-secondary); opacity: 0.8; }

    #ai-chatbox #ai-send-btn, #ai-chatbox #ai-show-variants {
        padding: 0; background: transparent; border: none; cursor: pointer;
        width: 44px; height: 44px; display: flex; align-items: center; justify-content: center;
        transition: all .4s cubic-bezier(.25, .8, .25, 1); border-radius: 50%;
    }
    #ai-chatbox #ai-send-btn:hover, #ai-chatbox #ai-show-variants:hover { transform: scale(1.1); box-shadow: var(--cyber-button-glow); }
    #ai-chatbox #ai-send-btn svg, #ai-chatbox #ai-show-variants svg { width: 20px; height: 20px; color: var(--cyber-text-accent); }

    /* Opțiuni rapide */
    #ai-chatbox .ai-options-container { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; float: left; clear: both; }
    #ai-chatbox .ai-option-btn {
        background: var(--cyber-bot-bubble-bg); border: 1px solid var(--cyber-border-color);
        color: var(--cyber-text-primary); padding: 12px 18px; border-radius: 20px; cursor: pointer;
        font-size: 13px; font-weight: 600; text-align: left; transition: all .3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3); animation: cyber-fadeIn .6s ease-out forwards;
    }
    #ai-chatbox .ai-option-btn:hover {
        background: var(--cyber-user-bubble-bg);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), var(--cyber-neon-glow);
    }

    #ai-chatbox .ai-link { text-decoration: none; }
    
    /* Card de produs - Futuristic */
    #ai-chatbox .ai-product-card-interactive {
        background: var(--cyber-card-bg);
        border: 1px solid var(--cyber-border-color);
        border-radius: 14px;
        margin-top: 12px; margin-bottom: 8px;
        float: left; clear: both; width: 100%; box-sizing: border-box; overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
        animation: cyber-fadeIn .6s ease-out forwards;
        display: flex; align-items: flex-start; padding: 12px; position: relative; transition: .4s;
        text-decoration: none;
        backdrop-filter: blur(8px);
    }
    #ai-chatbox .ai-product-card-interactive:hover { transform: translateY(-3px); box-shadow: var(--cyber-shadow-hover); }
    #ai-chatbox .ai-product-card-interactive-image-container {
        width: 90px; height: 90px; flex-shrink: 0; border-radius: 8px; overflow: hidden; margin-right: 12px;
        position: relative; border: 1px solid var(--cyber-border-color);
    }
    #ai-chatbox .ai-product-card-interactive-image { width: 100%; height: 100%; object-fit: cover; transition: transform .5s ease; }
    #ai-chatbox .ai-product-card-interactive:hover .ai-product-card-interactive-image { transform: scale(1.05); }

    #ai-chatbox .ai-product-card-interactive-content { flex: 1; display: flex; flex-direction: column; }
    #ai-chatbox .ai-product-card-interactive-title { color: var(--cyber-text-primary); font-weight: 700; font-size: 14px; margin-bottom: 5px; line-height: 1.3; }
    #ai-chatbox .ai-product-card-interactive-price { color: var(--cyber-text-accent); font-size: 13px; font-weight: 700; margin-bottom: 8px; }
    #ai-chatbox .ai-product-card-interactive-description { color: var(--cyber-text-secondary); font-size: 12px; line-height: 1.5; margin-bottom: 10px; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }

    #ai-chatbox .ai-product-card-interactive-actions { display: flex; align-items: center; margin-top: auto; }
    
    #ai-chatbox .ai-product-card-interactive-img-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
    }
    
    #ai-chatbox .ai-add-to-cart-btn {
        border: 1px solid var(--cyber-text-accent); border-radius: 12px;
        padding: 8px 12px; font-size: 12px; font-weight: 700; cursor: pointer; transition: .3s;
        text-align: center; background: var(--cyber-text-accent); color: var(--cyber-bg-dark);
        box-shadow: var(--cyber-neon-glow);
        width: 90px; /* Latimea egala cu imaginea */
    }
    #ai-chatbox .ai-add-to-cart-btn:hover { background: transparent; color: var(--cyber-text-accent); transform: translateY(-2px); box-shadow: 0 0 15px rgba(0, 255, 255, 0.4); }
    #ai-chatbox .ai-add-to-cart-btn:disabled { background: #414161; color: var(--cyber-text-secondary); cursor: not-allowed; opacity: .7; border: 1px solid #414161; }

    /* Notificare coș */
    #ai-chatbox .ai-cart-notification {
        text-align: center; padding: 8px 14px; font-size: 12px; color: var(--cyber-success-color); font-weight: 700;
        background: var(--cyber-success-bg); border-radius: 12px; margin-top: 8px;
        float: left; clear: both; width: auto; border: 1px solid rgba(39, 244, 127, 0.3);
        animation: cyber-fadeIn .5s ease-out forwards;
    }

    /* --- Stare parcată: bula stă pe muchie și nu se auto-deschide --- */
#ai-bubble-container.parked {
  position: fixed;
  right: 0;
  bottom: 120px; /* distanță de la baza ecranului */
  transform: translateY(50%); /* mută puțin în jos */
  width: 28px;
  height: 130px;
  background: linear-gradient(145deg, #00f0ff, #0072ff);
  border-radius: 12px 0 0 12px;
  box-shadow: 0 0 15px rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

#ai-bubble-container.parked:hover {
  box-shadow: 0 0 20px rgba(0,255,255,0.5);
}

#ai-bubble-container.parked #ai-ai-btn {
  display: none; /* ascunde bulina rotundă */
}

#ai-bubble-container.parked::after {
  content: "Chat AI";
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: white;
  letter-spacing: 1px;
}

#ai-bubble-container.parked #ai-invite-label {
  display: none;
}

    `;
    document.head.appendChild(style);
}

// =================================================================================
// SAFE-AREA MOBIL (X să nu intre sub bara de oră / notch)
// =================================================================================

function applyMobileSafeArea() {
    const chatbox = document.getElementById('ai-chatbox');
    if (!chatbox) return;

    // Doar pe mobil
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobile) {
        // Reset pe desktop, în caz de resize
        chatbox.style.marginTop = '';
        chatbox.style.height = '';
        chatbox.style.maxHeight = '';
        return;
    }

    // 1) Încearcă să citești safe-area real din CSS (Safari iOS o expune ca computed)
    const tmp = document.createElement('div');
    tmp.style.cssText = 'position:fixed;top:0;left:0;height:constant(safe-area-inset-top);height:env(safe-area-inset-top);';
    document.body.appendChild(tmp);
    const safeAreaTop = parseFloat(getComputedStyle(tmp).height) || 0;
    tmp.remove();

    // 2) Fallback dacă nu există safe-area (Android fără notch etc.)
    const baseTop = 16; // px spațiu vizual plăcut
    const topSpace = Math.max(baseTop, safeAreaTop);

    // 3) Aplică dimensiunile
    const vh = window.innerHeight; // mai stabil decât 100vh pe iOS
    const heightPx = Math.max(320, vh - topSpace); // previne înălțimi prea mici

    chatbox.style.marginTop = `${topSpace}px`;
    chatbox.style.height = `${heightPx}px`;
    chatbox.style.maxHeight = `${heightPx}px`;
}

function attachSafeAreaListeners() {
    let _safeAreaTimer;
    const debounced = () => {
        clearTimeout(_safeAreaTimer);
        _safeAreaTimer = setTimeout(applyMobileSafeArea, 120);
    };

    window.addEventListener('resize', debounced);
    window.addEventListener('orientationchange', debounced);
    window.addEventListener('focusin', debounced); // tastatură afișată
    window.addEventListener('focusout', debounced); // tastatură ascunsă
}

// =================================================================================
// CREAREA INTERFEȚEI (UI)
// =================================================================================

function createCyberneticChatBubble() {
    const bubbleContainer = document.createElement('div');
    bubbleContainer.id = 'ai-bubble-container';
    bubbleContainer.innerHTML = `
        <div id="ai-invite-label">Întreabă Tom GO AI </div>
        <div id="ai-ai-btn" title="Deschide Asistent AI" role="button" aria-label="Deschide Asistent AI">
            <div class="ai-icon-container">
                <svg class="ai-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.5C12.41 4.29 13.71 5.59 15.5 6C13.71 6.41 12.41 7.71 12 9.5C11.59 7.71 10.29 6.41 8.5 6C10.29 5.59 11.59 4.29 12 2.5Z" fill="currentColor"/><path d="M6 10.5C6.21 11.42 6.88 12.09 7.8 12.3C6.88 12.51 6.21 13.18 6 14.1C5.79 13.18 5.12 12.51 4.2 12.3C5.12 12.09 5.79 11.42 6 10.5Z" fill="currentColor"/><path d="M18.5 13C18.71 13.92 19.38 14.59 20.3 14.8C19.38 15.01 18.71 15.68 18.5 16.6C18.29 15.68 17.62 15.01 16.7 14.8C17.62 14.59 18.29 13.92 18.5 13Z" fill="currentColor"/></svg>
            </div>
        </div>
    `;
    document.body.appendChild(bubbleContainer);

    const wrapper = document.createElement('div');
    wrapper.id = 'ai-chat-bubble';
    wrapper.innerHTML = `
    <div id="ai-chatbox">
        <div id="ai-chat-header">
            <span id="ai-title" class="ai-title" aria-live="polite">Asistent AI TOM GO</span>
            <button id="ai-close" title="Închide" aria-label="Închide Chat">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
        </div>
        <div id="ai-chat-content" role="log" aria-live="polite"></div>
        <div id="ai-chat-footer">
            <!-- ▶️ Buton Arată variantele -->
            <button id="ai-show-variants" title="Arată variantele" aria-label="Arată variantele">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <!-- icon grid 2x2 -->
                    <rect x="4" y="4" width="7" height="7" stroke="currentColor" stroke-width="2" rx="1"/>
                    <rect x="13" y="4" width="7" height="7" stroke="currentColor" stroke-width="2" rx="1"/>
                    <rect x="4" y="13" width="7" height="7" stroke="currentColor" stroke-width="2" rx="1"/>
                    <rect x="13" y="13" width="7" height="7" stroke="currentColor" stroke-width="2" rx="1"/>
                </svg>
            </button>

            <input id="ai-chat-input" type="text" placeholder="Scrie întrebarea ta..." autocomplete="off" aria-label="Câmp de introducere mesaj"/>
            <button id="ai-send-btn" title="Trimite" aria-label="Trimite Mesaj">
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M3 20.999L21 12L3 3.001V10L17 12L3 14V20.999Z" fill="currentColor"/></svg>
            </button>
        </div>
    </div>
`;
document.body.appendChild(wrapper);



const parkedBubble = document.getElementById('ai-bubble-container');
if (parkedBubble) {
    parkedBubble.addEventListener('click', () => {
        if (parkedBubble.classList.contains('parked')) {
            setParked(false);
            openChat(false);
        }
    });
}
    // Adăugare event listeners
    const chatbox = document.getElementById('ai-chatbox');
    const aiBtnElement = document.getElementById('ai-ai-btn');
    const inviteLabelElement = document.getElementById('ai-invite-label');
    const bubbleContainerElement = document.getElementById('ai-bubble-container');

    aiBtnElement.addEventListener('mouseenter', () => {
        if (window.innerWidth > 768 && !chatbox.classList.contains('is-open')) {
            inviteLabelElement.style.opacity = '1';
            inviteLabelElement.style.transform = 'translateY(0)';
        }
    });
    aiBtnElement.addEventListener('mouseleave', () => {
        if (window.innerWidth > 768 && !chatbox.classList.contains('is-open')) {
            inviteLabelElement.style.opacity = '0';
            inviteLabelElement.style.transform = 'translateY(10px)';
        }
    });

    // La deschiderea din buton, pornește efectul o singură dată
    aiBtnElement.onclick = () => {
        if (typeof toggleChat === 'function') toggleChat();
        setTimeout(() => {
          const box = document.getElementById('ai-chatbox');
          if (box && box.classList.contains('is-open')) {
            typeTitleOnce("Asistent AI TOM GO", 35);
          }
        }, 120);
    };

    document.getElementById('ai-close').onclick = () => closeChat(true);
    document.getElementById('ai-send-btn').onclick = sendMessage;
    document.getElementById('ai-chat-input').onkeydown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    };

    // ▶️ handler pentru butonul din stânga inputului
    document.getElementById('ai-show-variants').onclick = () => {
        restartFunnelUI();
    };

    // Închide chatul la click în afara lui (doar pe desktop)
    if (window.innerWidth > 768) {
        document.addEventListener('click', (event) => {
            if (!chatbox || !chatbox.classList.contains('is-open')) return;

            const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
            const clickedInsideChat = path.includes(chatbox) || chatbox.contains(event.target);
            const clickedBubble = bubbleContainerElement && bubbleContainerElement.contains(event.target);

            if (!clickedInsideChat && !clickedBubble) {
                closeChat(true);
            }
        }, true);
    }

    // Fallback: dacă chatul e deja vizibil (ex: auto-open), rulează efectul
    setTimeout(() => {
      const box = document.getElementById('ai-chatbox');
      if (box && box.classList.contains('is-open')) {
        typeTitleOnce("Asistent AI TOM GO", 35);
      }
    }, 400);
}


// =================================================================================
// LOGICA DE INTERACȚIUNE CU CHAT-UL
// =================================================================================

function openChat(isAutoReopen = false, overrideMessage = null) {
    const chatbox = document.getElementById('ai-chatbox');
    const chatContent = document.getElementById('ai-chat-content');
const bubbleContainer = document.getElementById('ai-bubble-container');
if (bubbleContainer) {
    bubbleContainer.addEventListener('click', () => {
        if (bubbleContainer.classList.contains('parked')) {
            setParked(false); // scoatem starea parcată
            openChat(false);  // deschidem chat-ul
        }
    });
}
    if (isParked()) setParked(false); // dacă era parcat, îl deblocăm la deschidere manuală

    if (chatbox.classList.contains('is-open')) return;

    getCart(); // Actualizează contextul coșului la fiecare deschidere

    const previousScroll = chatContent.scrollTop;
    const previousHeight = chatContent.scrollHeight;

    chatbox.classList.add('is-open');
    bubbleContainer.style.display = 'none';

    // ✔ Recalculează safe-area când se deschide
    applyMobileSafeArea();

    setTimeout(() => {
        document.getElementById('ai-chat-input').focus();

        if (previousScroll && previousHeight) {
            const newHeight = chatContent.scrollHeight;
            const scrollDifference = newHeight - previousHeight;
            chatContent.scrollTop = previousScroll + scrollDifference;
        } else {
            scrollChatDown();
        }
    }, 150);

    if (overrideMessage) {
        appendBotMsg(overrideMessage, true, true);
    } else if (isAutoReopen) {
        appendBotMsg("Încă nu ai găsit ce căutai? Spune-mi și îți recomand ceva perfect! 😉", true, true);
    } else if (chatHistory.length === 0) {
        startPremiumWelcomeFunnel();
    }
}

function toggleChat() {
    clearTimeout(autoOpenTimer);
    const chatbox = document.getElementById('ai-chatbox');
    if (chatbox.classList.contains('is-open')) {
        closeChat(true);
    } else {
        openChat();
    }
}

function closeChat(userInitiated = false) {
  const chatbox = document.getElementById('ai-chatbox');
  const bubbleContainer = document.getElementById('ai-bubble-container');

  if (!chatbox.classList.contains('is-open')) return;

  chatbox.classList.remove('is-open');

  setTimeout(() => {
    bubbleContainer.style.display = 'flex';
    chatbox.style.display = 'flex';
    if (userInitiated) {
      // PARCHEAZĂ: oprește complet auto-open până la următoarea deschidere manuală
      setParked(true);
      clearTimeout(autoOpenTimer);
    }
  }, 500);
}

function scheduleNextAutoOpen() {
    clearTimeout(autoOpenTimer);
    userCloseCount++;
    let delay;
    if (userCloseCount === 1) delay = 60 * 2000; // 1 minut
    else if (userCloseCount === 2) delay = 5 * 60 * 1000; // 5 minute
    else return; // Nu mai redeschide automat

    autoOpenTimer = setTimeout(() => openChat(true), delay);
}

function safeAbs(url) {
    if (!url) return '';
    const u = String(url);
    if (u.startsWith('http')) return u;
    if (u.startsWith('//')) return 'https:' + u;
    if (u.startsWith('/')) return location.origin + u;
    return 'https://' + u.replace(/^https?:\/\//, '');
}

// ───────────────────────────────────────────────
// FUNNEL INTELIGENT TOMGO (v3.1) — context-aware + scoring + bugfix „free”
// ───────────────────────────────────────────────

let currentStep = null;
let autoDetectTimer = null;

// ====== Stare + hidratare sigură (evită undefined.free)
const DEFAULT_STATE = {
    intent: null,
    // Cadou
    recipient: null,
    relation: null,
    occasion: null,
    // Decor
    decorType: null,
    decorStyle: null,
    decorTheme: null,
    // Mesaj
    messageTone: null,
    // Personalizare
    personalizationWanted: null,
    personalizationStyle: null,
    // Free text pentru „Altul/Altă…”
    free: {
        recipient: null,
        relation: null,
        occasion: null,
        decorType: null,
        decorStyle: null,
        decorTheme: null
    }
};

function hydrateState(raw) {
    const base = { ...DEFAULT_STATE, ...(raw || {})
    };
    base.free = { ...DEFAULT_STATE.free, ...(raw?.free || {})
    };
    return base;
}
const funnelState = hydrateState(JSON.parse(sessionStorage.getItem('tg_funnel_state_v2') || 'null'));
const stepsVisited = JSON.parse(sessionStorage.getItem('tg_funnel_visited_v2') || '[]');

// ====== Structură pași
const FUNNEL_STRUCTURE = {
    "cadou personalizat": ["recipient", "relation", "occasion", "personalizationWanted", "personalizationStyle"],
    "decorațiuni personalizate": ["decorType", "decorStyle", "decorTheme", "personalizationWanted", "personalizationStyle"],
    "mesaj personalizat": ["occasion", "messageTone", "recipient"]
};

// ====== Opțiuni globale (bază)
const OPTIONS = {
    recipient: ["Femeie", "Bărbat", "Cuplu", "Copil", "Altul"],
    // fără „/” — forme separate pe gen
    relation: ["Iubit", "Iubită", "Soț", "Soție", "Părinte", "Prieten", "Prietena",
        "Coleg", "Colega", "Șef", "Șefă", "Profesor", "Profesoară", "Nași/Fin(i)", "Altul"
    ],
    occasion: ["Zi de naștere", "Aniversare", "Nuntă", "Naștere copil", "Absolvire", "Crăciun", "Altă ocazie"],

    personalizationWanted: ["Da", "Nu"],
    personalizationStyle: ["Elegant", "Haios", "Alt stil"],

    decorType: ["Living", "Dormitor", "Bucătărie", "Birou", "Exterior", "Altul"],
    decorStyle: ["Modern", "Rustic", "Minimalist", "Artistic", "Altul"],
    decorTheme: ["Florale", "Natură", "Abstract", "Personalizate cu text", "Altă temă"],

    messageTone: ["Elegant", "Haios", "Romantic", "Emoționant", "Motivațional", "Inspirat", "Amoros", "Nostalgic"]
};

// ====== Întrebări
const QUESTIONS = {
    recipient: "Pentru cine este cadoul?",
    relation: "Care este relația cu persoana?",
    occasion: "Ce ocazie sărbătoriți?",
    personalizationWanted: "Vrei să personalizăm produsul?",
    personalizationStyle: "Ce tip de personalizare preferi?",
    decorType: "Pentru ce tip de spațiu cauți decorațiuni?",
    decorStyle: "Ce stil preferi?",
    decorTheme: "Ce tematică te atrage?",
    messageTone: "Ce ton să aibă mesajul?"
};

// ====== REGULI DEPENDENTE DE CONTEXT
const DYNAMIC_RULES = {
    // Relații afișate în funcție de recipient (din perspectiva destinatarului)
    relationByRecipient: {
        "Femeie": ["Iubită", "Soție", "Prietena", "Colega", "Șefă", "Profesoară", "Părinte", "Altul"],
        "Bărbat": ["Iubit", "Soț", "Părinte", "Prieten", "Coleg", "Șef", "Profesor", "Altul"],
        "Cuplu": ["Soț", "Soție", "Nași/Fin(i)", "Prieten", "Prietena", "Altul"],
        "Copil": ["Părinte", "Altul"],
        "Altul": ["Iubit", "Iubită", "Soț", "Soție", "Părinte", "Prieten", "Prietena", "Coleg", "Colega", "Șef", "Șefă", "Profesor", "Profesoară", "Nași/Fin(i)", "Altul"]
    },

    // Ocazii valide în funcție de relație / recipient
    occasionByRelation: {
        "Iubit": ["Zi de naștere", "Aniversare", "Crăciun", "Altă ocazie"],
        "Iubită": ["Zi de naștere", "Aniversare", "Crăciun", "Altă ocazie"],
        "Soț": ["Zi de naștere", "Aniversare", "Nuntă", "Crăciun", "Altă ocazie"],
        "Soție": ["Zi de naștere", "Aniversare", "Nuntă", "Crăciun", "Altă ocazie"],
        "Părinte": ["Zi de naștere", "Crăciun", "Altă ocazie"], // ⛔ fără „Absolvire”
        "Prieten": ["Zi de naștere", "Aniversare", "Crăciun", "Altă ocazie"],
        "Prietena": ["Zi de naștere", "Aniversare", "Crăciun", "Altă ocazie"],
        "Coleg": ["Zi de naștere", "Altă ocazie"],
        "Colega": ["Zi de naștere", "Altă ocazie"],
        "Șef": ["Zi de naștere", "Altă ocazie"],
        "Șefă": ["Zi de naștere", "Altă ocazie"],
        "Profesor": ["Zi de naștere", "Altă ocazie"],
        "Profesoară": ["Zi de naștere", "Altă ocazie"],
        "Nași/Fin(i)": ["Nuntă", "Zi de naștere", "Altă ocazie"],
        "Altul": ["Zi de naștere", "Altă ocazie"]
    },
    occasionByRecipient: {
        "Cuplu": ["Nuntă", "Aniversare", "Zi de naștere", "Crăciun", "Altă ocazie"],
        "Copil": ["Zi de naștere", "Naștere copil", "Altă ocazie"]
    },

    // Ton preferat după ocazie
    toneByOccasion: {
        "Nuntă": ["Elegant", "Romantic", "Emoționant"],
        "Aniversare": ["Romantic", "Elegant", "Emoționant"],
        "Zi de naștere": ["Haios", "Elegant", "Emoționant"],
        "Crăciun": ["Elegant", "Emoționant", "Haios"],
        "Naștere copil": ["Emoționant", "Elegant"],
        "Absolvire": ["Elegant", "Emoționant"]
    },

    // Stil personalizare după intent + ton
    personalizationStyleByContext({
        intent,
        messageTone
    }) {
        if (intent === "mesaj personalizat") {
            if (messageTone === "Haios") return ["Haios", "Alt stil"];
            if (messageTone === "Romantic") return ["Elegant", "Romantic", "Alt stil"];
            return ["Elegant", "Alt stil"];
        }
        return ["Elegant", "Haios", "Alt stil"];
    },

    // Decor → stiluri valide
    decorStyleByType: {
        "Living": ["Modern", "Rustic", "Minimalist", "Artistic"],
        "Dormitor": ["Modern", "Minimalist", "Artistic"],
        "Bucătărie": ["Modern", "Rustic", "Minimalist"],
        "Birou": ["Modern", "Minimalist", "Artistic"],
        "Exterior": ["Rustic", "Artistic"]
    }
};

// ====== Helperi UI (stubs — înlocuiește cu implementările tale)
function appendBotMsg(text, compact = false, animated = true) {
    const chat = document.getElementById('ai-chat-content');
    if (!chat) return;

    if (animated) {
        // Pentru mesaje animate, creăm elementul și îl populăm gradual
        const div = document.createElement('div');
        div.className = `ai-msg ai-bot${compact?' compact':''}`;
        chat.appendChild(div);

        // Functia care se va ocupa de animatie
        const typewrite = (el, msg) => {
            let i = 0;
            const timer = setInterval(() => {
                if (i < msg.length) {
                    el.innerHTML += htmlEntities(msg.charAt(i));
                    scrollChatDown(); // Asigurăm scroll la fiecare literă
                    i++;
                } else {
                    clearInterval(timer);
                    el.classList.add('ai-msg-appear'); // Adaugă clasa de animație finală
                }
            }, 10); // Viteză de scriere (10ms/caracter, de două ori mai rapid)
        };
        typewrite(div, text);

    } else {
        // Pentru mesaje non-animate (istoric), populăm imediat
        const div = document.createElement('div');
        div.className = `ai-msg ai-bot${compact?' compact':''} ai-msg-appear`;
        div.innerHTML = formatLinks(text).replace(/\n/g, '<br>');
        chat.appendChild(div);
    }
}

function appendUserMsg(text, compact = false) {
    const chat = document.getElementById('ai-chat-content');
    if (!chat) return;
    const div = document.createElement('div');
    div.className = `ai-msg ai-user${compact?' compact':''}`;
    div.textContent = text;
    chat.appendChild(div);
}

function scrollChatDown() {
    const chat = document.getElementById('ai-chat-content');
    if (chat) chat.scrollTop = chat.scrollHeight;
}

function showProductCards(products) {
    products.forEach(p => {
        const line = `• ${p.title} — ${p.reasons?.slice(0, 3).join(', ') || ''}`;
        appendBotMsg(line, true);
    });
}

// ====== Utilitare
function persistState() {
    sessionStorage.setItem('tg_funnel_state_v2', JSON.stringify(funnelState));
    sessionStorage.setItem('tg_funnel_visited_v2', JSON.stringify(stepsVisited));
}

function clearOpenOptionGroups() {
    const chat = document.getElementById('ai-chat-content');
    if (!chat) return;
    chat.querySelectorAll('.ai-options-container').forEach(el => el.remove());
    chat.querySelectorAll('.ai-freefill').forEach(el => el.remove());
}

function restartFunnelUI() {
    clearTimeout(autoDetectTimer);
    clearOpenOptionGroups();
    Object.keys(DEFAULT_STATE).forEach(k => {
        funnelState[k] = (k === 'free') ? { ...DEFAULT_STATE.free
        } : null;
    });
    stepsVisited.length = 0;
    persistState();
    appendBotMsg("Hai să începem din nou. Ce te interesează astăzi? ✨", true);
    showIntentOptions();
}

// ====== Intent + autodetecție
function showIntentOptions() {
    const chat = document.getElementById('ai-chat-content');
    if (!chat) return;
    clearOpenOptionGroups();

    appendBotMsg("Cu ce te ajut azi? Alege sau spune-mi liber în text. ✨", true);

    const wrap = document.createElement('div');
    wrap.className = 'ai-options-container';

    ["cadou personalizat", "decorațiuni personalizate", "mesaj personalizat"].forEach(it => {
        const b = document.createElement('button');
        b.className = 'ai-option-btn';
        b.innerHTML = it;
        b.onclick = () => {
            funnelState.intent = it;
            if (!stepsVisited.includes('intent')) stepsVisited.push('intent');
            persistState();
            clearOpenOptionGroups();
            nextFunnelStep();
        };
        wrap.appendChild(b);
    });

    chat.appendChild(wrap);
    scrollChatDown();

    scheduleAutoDetect();
}

function scheduleAutoDetect() {
    clearTimeout(autoDetectTimer);
    autoDetectTimer = setTimeout(() => {
        const lastUser = getLastUserMessage();
        if (!lastUser) return;
        const guess = nluGuess(lastUser);
        if (guess.intent && !funnelState.intent) {
            funnelState.intent = guess.intent;
            if (!stepsVisited.includes('intent')) stepsVisited.push('intent');
            appendBotMsg(`Am înțeles: ${guess.intent}.`, true);
        }
        ["recipient", "relation", "occasion", "decorType", "decorStyle", "decorTheme", "messageTone", "personalizationWanted"].forEach(key => {
            if (guess[key] && !funnelState[key]) funnelState[key] = guess[key];
        });
        persistState();
        if (funnelState.intent) nextFunnelStep();
    }, 400);
}

function getLastUserMessage() {
    const chat = document.getElementById('ai-chat-content');
    if (!chat) return null;
    const msgs = [...chat.querySelectorAll('.ai-msg.user')].map(n => n.textContent?.trim()).filter(Boolean);
    return msgs.length ? msgs[msgs.length - 1] : null;
}

// ====== NLU simplu (regex)
function nluGuess(textRaw) {
    const text = (textRaw || "").toLowerCase();

    const mapIntent = [{
        k: "cadou personalizat",
        re: /(cadou|dar|personaliza)/
    }, {
        k: "decorațiuni personalizate",
        re: /(decor|tablou|perete|stil|living|dormitor)/
    }, {
        k: "mesaj personalizat",
        re: /(mesaj|text|urare|felicitare)/
    }, ];
    const mapRecipient = [{
        k: "Femeie",
        re: /(femeie|ea|iubită|prietenă|soție|mama|mamă|nașă|bunica|colegă|profesoară)/
    }, {
        k: "Bărbat",
        re: /(bărbat|el|iubit|prieten|soț|tata|tată|naș|bunic|coleg|profesor|șef)/
    }, {
        k: "Cuplu",
        re: /(cuplu|amândoi|amîndoi|nasi|nași|fini|miri)/
    }, {
        k: "Copil",
        re: /(copil|bebe|bebel|fetiță|băiat)/
    }];
    const mapOccasion = [{
        k: "Zi de naștere",
        re: /(ziua|anivers|la mulți ani)/
    }, {
        k: "Nuntă",
        re: /(nunt|miri|nași|nașa|naș)/
    }, {
        k: "Naștere copil",
        re: /(naștere|botez|bebeluș|bebelus)/
    }, {
        k: "Absolvire",
        re: /(absolv|licenț|bac)/
    }, {
        k: "Crăciun",
        re: /(crăciun|mos craciun|sărbători)/
    }];
    const mapTone = [{
        k: "Elegant",
        re: /(elegant|clasic|rafina)/
    }, {
        k: "Haios",
        re: /(haios|amuzant|glum|funny)/
    }, {
        k: "Romantic",
        re: /(romantic|iubire|dragoste|inim)/
    }, {
        k: "Emoționant",
        re: /(emoționant|emoție|sensibil|lacrim)/
    }];
    const mapDecorType = [{
        k: "Living",
        re: /(living|sufragerie)/
    }, {
        k: "Dormitor",
        re: /(dormitor|pat)/
    }, {
        k: "Bucătărie",
        re: /(bucătărie|bucatarie)/
    }, {
        k: "Birou",
        re: /(birou|office|workspace)/
    }, {
        k: "Exterior",
        re: /(terasă|balcon|curte|gradină|gradina)/
    }];
    const mapDecorStyle = [{
        k: "Modern",
        re: /(modern|contemporan|minimal)/
    }, {
        k: "Rustic",
        re: /(rustic|lemn|vintage)/
    }, {
        k: "Minimalist",
        re: /(minimal|curat|aerisit)/
    }, {
        k: "Artistic",
        re: /(artistic|abstract|art)/
    }];
    const mapYesNo = [{
        k: "Da",
        re: /(personaliz|grav|nume|inițial|initial|poza|poză|foto)/
    }, ];

    const pick = (maps) => {
        for (const m of maps)
            if (m.re.test(text)) return m.k;
        return null;
    };

    return {
        intent: pick(mapIntent),
        recipient: pick(mapRecipient),
        occasion: pick(mapOccasion),
        messageTone: pick(mapTone),
        decorType: pick(mapDecorType),
        decorStyle: pick(mapDecorStyle),
        personalizationWanted: pick(mapYesNo) ? "Da" : null
    };
}

// ====== Opțiuni dinamice (filtrate după context)
function getOptions(stepKey, state) {
    let base = [...(OPTIONS[stepKey] || [])];

    if (stepKey === "relation" && state.recipient) {
        const map = DYNAMIC_RULES.relationByRecipient[state.recipient];
        if (map) base = intersect(base, map.concat(hasAlt(base)));
    }

    if (stepKey === "occasion") {
        let allowed = null;
        if (state.relation && DYNAMIC_RULES.occasionByRelation[state.relation]) {
            allowed = DYNAMIC_RULES.occasionByRelation[state.relation];
        } else if (state.recipient && DYNAMIC_RULES.occasionByRecipient[state.recipient]) {
            allowed = DYNAMIC_RULES.occasionByRecipient[state.recipient];
        }
        if (allowed) base = intersect(base, allowed.concat(hasAlt(base)));
    }

    if (stepKey === "messageTone" && state.occasion && DYNAMIC_RULES.toneByOccasion[state.occasion]) {
        base = intersect(base, DYNAMIC_RULES.toneByOccasion[state.occasion]);
    }

    if (stepKey === "personalizationStyle") {
        const list = DYNAMIC_RULES.personalizationStyleByContext({
            intent: state.intent,
            messageTone: state.messageTone
        });
        base = intersect(base, list);
        if (state.personalizationWanted === "Nu") return []; // skip complet
    }

    if (stepKey === "decorStyle" && state.decorType && DYNAMIC_RULES.decorStyleByType[state.decorType]) {
        base = intersect(base, DYNAMIC_RULES.decorStyleByType[state.decorType].concat(hasAlt(base)));
    }

    return base;

    function intersect(a, b) {
        const setB = new Set(b);
        return a.filter(x => setB.has(x));
    }

    function hasAlt(arr) {
        return arr.some(x => /Alt(ă|ul)/i.test(x)) ? ["Altă ocazie", "Altul"] : [];
    }
}

// ====== UI: grup de opțiuni
function renderChoiceGroup(stepKey) {
    const chat = document.getElementById('ai-chat-content');
    if (!chat) return;

    currentStep = stepKey;
    let opts = getOptions(stepKey, funnelState);

    // Nimic de arătat? (ex: personalizationStyle când e „Nu”) → treci mai departe
    if (!opts || opts.length === 0) {
        nextFunnelStep();
        return;
    }

    appendBotMsg(QUESTIONS[stepKey], true);

    const wrap = document.createElement('div');
    wrap.className = 'ai-options-container';

    // Înapoi
    if (stepsVisited.length > 0) {
        const backBtn = document.createElement('button');
        backBtn.className = 'ai-option-btn';
        backBtn.innerHTML = "←";
        backBtn.onclick = onBackClick;
        wrap.appendChild(backBtn);
    }

    // Opțiuni
    opts.forEach((text) => {
        const btn = document.createElement('button');
        btn.className = 'ai-option-btn';
        btn.innerHTML = text;
        btn.setAttribute('data-step', stepKey);
        btn.setAttribute('data-value', text);
        btn.onclick = onChipClick;
        wrap.appendChild(btn);
    });



    chat.appendChild(wrap);
    scrollChatDown();
}

function onChipClick(e) {
    e.stopPropagation();
    const btn = e.currentTarget;
    const step = btn.getAttribute('data-step');
    const value = btn.getAttribute('data-value');

    funnelState[step] = value;
    appendUserMsg(value, true);

    if (!stepsVisited.includes(step)) stepsVisited.push(step);

    // Short-circuit: dacă nu vrea personalizare → pune „Fără personalizare”
    if (step === "personalizationWanted" && value === "Nu") {
        funnelState.personalizationStyle = "Fără personalizare";
        if (!stepsVisited.includes("personalizationStyle")) stepsVisited.push("personalizationStyle");
    }

    persistState();
    clearOpenOptionGroups();
    nextFunnelStep();
}

function onBackClick() {
    if (stepsVisited.length === 0) {
        restartFunnelUI();
        return;
    }
    const target = stepsVisited.pop();
    funnelState[target] = null;
    if (funnelState.free?.[target]) funnelState.free[target] = null;

    if (target === "personalizationWanted") {
        funnelState.personalizationStyle = null;
        const idx = stepsVisited.indexOf("personalizationStyle");
        if (idx !== -1) stepsVisited.splice(idx, 1);
    }

    persistState();
    clearOpenOptionGroups();
    appendBotMsg(`Am revenit: ${QUESTIONS[target]}`, true);
    renderChoiceGroup(target);
}

// ====== Orchestrare pași
function nextFunnelStep() {
    const intentKey = funnelState.intent;
    if (!intentKey) {
        showIntentOptions();
        return;
    }

    const steps = [...FUNNEL_STRUCTURE[intentKey]];

    // Skip-uri soft
    if (funnelState.recipient === "Copil" || funnelState.recipient === "Cuplu") {
        const i = steps.indexOf('relation');
        if (i > -1) steps.splice(i, 1);
    }
    if (funnelState.personalizationWanted === "Nu") {
        const i = steps.indexOf('personalizationStyle');
        if (i > -1) steps.splice(i, 1);
    }

    const nextKey = steps.find(key => !funnelState[key]);
    if (nextKey) {
        renderChoiceGroup(nextKey);
        return;
    }

    runRecommendationFromFunnel();
}

// ====== Recomandări (scorare)
function runRecommendationFromFunnel() {
    const summary = buildSummaryForAI();
    appendBotMsg("Super! Pregătesc recomandările tale personalizate… ✨", true, true);
    chatHistory.push({
        role: 'user',
        content: summary
    });
    saveHistory();

    removeTyping();
    appendTyping();
    askAi(chatHistory).then((aiResponse) => {
        removeTyping();
        const responseText = aiResponse || "Îmi pare rău, momentan nu pot genera o recomandare.";
        
        if (funnelState.intent === 'mesaj personalizat') {
            const messages = responseText.split('---').map(s => s.trim()).filter(Boolean);
            messages.forEach(msg => {
                appendBotMsg(msg, true, true);
            });
        } else {
            appendBotMsg(responseText, true, true);
        }

        // Buton „Selectează din nou”
        const chat = document.getElementById('ai-chat-content');
        const wrap = document.createElement('div');
        wrap.className = 'ai-options-container';

        const restartBtn = document.createElement('button');
        restartBtn.className = 'ai-option-btn';
        restartBtn.innerHTML = "🔄 Selectează din nou";
        restartBtn.onclick = () => {
            resetFunnel(false);
            appendBotMsg("Hai să refacem selecția. 😊", true);
            showIntentOptions();
        };

        wrap.appendChild(restartBtn);
        chat.appendChild(wrap);
        scrollChatDown();

    }).catch(() => {
        removeTyping();
        appendBotMsg("A apărut o eroare. Reîncearcă.");
    });
}


function buildCriteria() {
    const c = {
        intent: funnelState.intent,
        pentru: normalizePentru(funnelState.recipient, funnelState.relation, funnelState.free),
        ocazie: normalizeOcazie(funnelState.occasion, funnelState.free),
        decor: {
            type: valOrFree('decorType'),
            style: valOrFree('decorStyle'),
            theme: valOrFree('decorTheme')
        },
        tone: funnelState.messageTone,
        personalization: funnelState.personalizationWanted === "Da" ? "da" : "nu",
        personalizationStyle: funnelState.personalizationWanted === "Da" ? funnelState.personalizationStyle : "fara"
    };
    return c;

    function valOrFree(key) {
        return funnelState[key] === "Altul" || /Alt(ă|ul)/i.test(funnelState[key] || "") ? (funnelState.free?.[key] || null) : (funnelState[key] || null);
    }
}

function normalizePentru(recipient, relation, free) {
    const map = {
        "Femeie": ["Femei", "Soție", "Iubită", "Mamă", "Nașă", "Colega", "Profesoară", "Bunica"],
        "Bărbat": ["Bărbați", "Soț", "Iubit", "Tată", "Naș", "Coleg", "Profesor", "Bunic"],
        "Cuplu": ["Nași", "Cuplu", "Miri", "Părinți", "Fini"],
        "Copil": ["Bebeluş", "Copil", "Fiu", "Fiică"]
    };
    let bucket = [];
    if (map[recipient]) bucket = bucket.concat(map[recipient]);

    const alias = {
        "Iubit": "Iubită",
        "Iubită": "Iubit",
        "Prieten": "Prietena",
        "Prietena": "Prieten",
        "Coleg": "Colega",
        "Colega": "Coleg",
        "Șef": "Șefă",
        "Șefă": "Șef",
        "Profesor": "Profesoară",
        "Profesoară": "Profesor"
    };

    if (relation && relation !== "Altul") {
        bucket.unshift(relation);
        if (alias[relation]) bucket.push(alias[relation]); // familie semantică
    } else if (relation === "Altul" && free?.relation) {
        bucket.unshift(capitalize(free.relation));
    }
    if (recipient === "Altul" && free?.recipient) bucket.push(capitalize(free.recipient));
    return bucket.filter(Boolean);
}

function normalizeOcazie(occasion, free) {
    if (!occasion) return [];
    if (/Altă ocazie/i.test(occasion)) return free?.occasion ? [capitalize(free.occasion)] : [];
    return [occasion];
}

function capitalize(s) {
    return (s || "").charAt(0).toUpperCase() + (s || "").slice(1);
}

function scoreProducts(items, criteria) {
    const wantedPentru = (criteria.pentru || []).map(norm);
    const wantedOcazie = (criteria.ocazie || []).map(norm);
    const wantsPerso = criteria.personalization === 'da';

    return items.map(p => {
        const tags = (p.tags || []).map(norm);
        const mPentru = norm(getMetafield(p, 'custom.Pentru') || getMetafield(p, 'Pentru') || "");
        const mAllPentru = mPentru ? [mPentru] : [];
        const bagPentru = new Set(tags.concat(mAllPentru));

        let score = 0,
            reasons = [];

        // Intent
        if (criteria.intent === "cadou personalizat" && tags.includes('personalizabil')) {
            score += 8;
            reasons.push('Intent: cadou personalizat');
        }
        if (criteria.intent === "decorațiuni personalizate" && (tags.includes('gravura lemn') || tags.includes('tablouri'))) {
            score += 6;
            reasons.push('Intent: decorațiuni');
        }
        if (criteria.intent === "mesaj personalizat" && (tags.includes('personalizare text') || tags.includes('mesaj'))) {
            score += 5;
            reasons.push('Intent: mesaj');
        }

        // Pentru
        let matchPentru = 0;
        wantedPentru.forEach(w => {
            if (bagPentru.has(w)) {
                score += 5;
                matchPentru++;
            }
        });
        if (matchPentru) reasons.push(`Potrivire „Pentru” (${matchPentru})`);

        // Ocazie
        let matchOcc = 0;
        wantedOcazie.forEach(w => {
            if (tags.includes(w)) {
                score += 4;
                matchOcc++;
            }
        });
        if (matchOcc) reasons.push(`Ocazie ✓`);

        // Personalizare
        if (wantsPerso && (tags.includes('personalizabil') || tags.includes('personalizare'))) {
            score += 4;
            reasons.push('Personalizare ✓');
        }
        if (!wantsPerso && !tags.includes('personalizabil')) {
            score += 1;
        }

        // Decor
        if (criteria.decor.type && fuzzIn(tags, criteria.decor.type)) {
            score += 2;
            reasons.push('Tip spațiu ✓');
        }
        if (criteria.decor.style && fuzzIn(tags, criteria.decor.style)) {
            score += 2;
            reasons.push('Stil ✓');
        }
        if (criteria.decor.theme && fuzzIn(tags, criteria.decor.theme)) {
            score += 2;
            reasons.push('Temă ✓');
        }

        // Ton
        if (criteria.tone && (fuzzIn(tags, criteria.tone) || fuzzIn(tags, toneAlias(criteria.tone)))) {
            score += 2;
            reasons.push('Ton ✓');
        }

        if (p.images?.length) score += 0.5;
        if (p.available !== false) score += 0.5;

        return { ...p,
            score,
            reasons
        };
    });

    function norm(s) {
        return String(s || "").toLowerCase().trim();
    }

    function getMetafield(p, key) {
        if (!p.metafields) return null;
        if (key in p.metafields) return p.metafields[key];
        const suffix = '.' + key.split('.').pop();
        const found = Object.keys(p.metafields).find(k => k.endsWith(suffix));
        return found ? p.metafields[found] : null;
    }

    function fuzzIn(arr, token) {
        if (!token) return false;
        const t = norm(token);
        return arr.some(a => norm(a).includes(t));
    }

    function toneAlias(t) {
        const m = {
            "Elegant": ["clasic", "rafina"],
            "Haios": ["amuzant", "gluma"],
            "Romantic": ["inima", "dragoste", "iubire"],
            "Emoționant": ["emoționant", "sensibil"]
        };
        return (m[t] || [])[0] || t;
    }
}

// ====== Public API
function startFunnelSmart() {
    if (!funnelState.intent) {
        showIntentOptions();
    } else {
        nextFunnelStep();
    }
}

function restartFunnelPublic() {
    restartFunnelUI();
}

// ====== QoL: re-analizează când userul tastează
document.addEventListener('keyup', (e) => {
    if (e.target && e.target.closest && e.target.closest('#ai-chat-input')) {
        scheduleAutoDetect();
    }
});

// Expune pe window (dacă vrei să le apelezi din alt script)
window.TG_Funnel = {
    start: startFunnelSmart,
    restart: restartFunnelPublic
};



// ───────────────────────────────────────────────
// Rezumat + cerere recomandări (în funcție de intent)
// ───────────────────────────────────────────────

function buildSummaryForAI() {
    const intent = funnelState.intent;

    if (intent === "cadou personalizat") {
        return `Preferințe selectate (cadou):
    - Destinatar: ${funnelState.recipient} (${funnelState.relation})
    - Ocazie: ${funnelState.occasion}
    - Personalizare: ${funnelState.personalizationWanted}
    - Tip personalizare: ${funnelState.personalizationStyle}
    
    Te rog recomandă 2–3 produse potrivite. Pentru fiecare recomandare, folosește formatul [PRODUCT_CARD:handle-ul-produsului]. Între mesajul de descriere și cardul de produs, folosește un mesaj separat. Propune automat un text de personalizare în stilul selectat (dacă nu e "Fără personalizare"), înainte de a recomanda produsul.`;
    }

    if (intent === "decorațiuni personalizate") {
        return `Preferințe selectate (decorațiuni):
    - Spațiu: ${funnelState.decorType}
    - Stil: ${funnelState.decorStyle}
    - Tematică: ${funnelState.decorTheme}
    - Personalizare: ${funnelState.personalizationWanted}
    - Tip personalizare: ${funnelState.personalizationStyle}
    
    Te rog recomandă 2–3 produse potrivite. Pentru fiecare recomandare, folosește formatul [PRODUCT_CARD:handle-ul-produsului]. Între mesajul de descriere și cardul de produs, folosește un mesaj separat. Propune automat un text de personalizare în stilul selectat (dacă nu e "Fără personalizare"), înainte de a recomanda produsul.`;
    }

    // mesaj personalizat
    return `Preferințe selectate (mesaj):
    - Ocazie: ${funnelState.occasion}
    - Ton: ${funnelState.messageTone}
    - Destinatar: ${funnelState.recipient}
    
    Te rog generează 3 variante scurte de mesaj în tonul selectat, separate prin "---". Nu recomanda produse, ci doar mesajele.`;
}

// ───────────────────────────────────────────────
// Inițializare + Intenturi
// ───────────────────────────────────────────────

function resetFunnel(soft = false) {
    currentStep = null;
    stepsVisited.length = 0;

    const keepIntent = soft;
    const intentCache = funnelState.intent;

    Object.keys(funnelState).forEach(k => funnelState[k] = null);
    if (keepIntent) funnelState.intent = intentCache;
}

function showIntentOptions() {
    const chatContent = document.getElementById('ai-chat-content');
    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'ai-options-container';

    [
        "🎁 Cadou Personalizat",
        "🖼️ Decorațiuni",
        "💡 Mesaj Personalizat"
    ].forEach(optionText => {
        const button = document.createElement('button');
        button.className = 'ai-option-btn';
        button.innerHTML = optionText;
        button.onclick = (event) => {
            event.stopPropagation();
            handlePremiumFunnelChoice(optionText);
            optionsContainer.remove();
        };
        optionsContainer.appendChild(button);
    });

    chatContent.appendChild(optionsContainer);
    scrollChatDown();
}

function startPremiumWelcomeFunnel() {
    resetFunnel(false);
    appendBotMsg(
        "Bun venit la **TOM GO**! ✨ Alegem rapid, fără tastat. Ce te interesează astăzi?",
        true
    );
    setTimeout(() => {
        showIntentOptions();
    }, 500);
}

function handlePremiumFunnelChoice(choice) {
    appendUserMsg(choice, true);

    switch (choice) {
        case "🎁 Cadou Personalizat":
            funnelState.intent = "cadou personalizat";
            appendBotMsg("Excelent! Hai să-ți potrivim cadoul perfect în câțiva pași.", true);
            break;
        case "🖼️ Decorațiuni":
            funnelState.intent = "decorațiuni personalizate";
            appendBotMsg("Minunat! Stabilim rapid spațiul, stilul și tematica.", true);
            break;
        case "💡 Mesaj Personalizat":
            funnelState.intent = "mesaj personalizat";
            appendBotMsg("Perfect. Începem cu ocazia și tonul mesajului.", true);
            break;
    }

    // Pornim primul pas din structura intentului ales
    nextFunnelStep();
}



// =================================================================================
// FUNCȚII UTILITARE (ISTORIC, SCROLL, HELPERS) — versiune fără coliziuni
// =================================================================================

const htmlEntities = (str) =>
    str ? str.replace(/</g, '&lt;').replace(/>/g, '&gt;') : '';

const formatLinks = (msg) =>
    msg ? msg.replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
        '<a href="$2" class="ai-link" target="_blank" rel="noopener noreferrer">$1</a>'
    ) : '';

// ✅ stripHtml mutat în namespace + protejat împotriva redeclarării
(function ensureStripHtml() {
    window.TOMGO = window.TOMGO || {};
    if (typeof window.TOMGO.stripHtml !== 'function') {
        window.TOMGO.stripHtml = function(html) {
            try {
                const doc = new DOMParser().parseFromString(html || '', 'text/html');
                return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
            } catch {
                // fallback sigur
                return String(html || '')
                    .replace(/<[^>]*>/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim();
            }
        };
    }
})();

function scrollChatDown() {
    const chat = document.getElementById('ai-chat-content');
    if (chat) {
        setTimeout(() => chat.scrollTo({
            top: chat.scrollHeight,
            behavior: 'smooth'
        }), 100);
    }
}

function saveHistory() {
    try {
        if (chatHistory.length > 15) chatHistory = chatHistory.slice(-15); // hard cap
        localStorage.setItem(chatKey, JSON.stringify({
            date: Date.now(),
            msgs: chatHistory
        }));
    } catch (e) {
        console.error('Nu s-a putut salva istoricul:', e);
    }
}


function restoreHistory() {
    try {
        const data = localStorage.getItem(chatKey);
        if (!data) return;
        const saved = JSON.parse(data);
        if (Date.now() - saved.date < historyTtl) {
            chatHistory = (saved.msgs || []);
            if (chatHistory.length > 15) chatHistory = chatHistory.slice(-15); // cap la load
            if (chatHistory.length > 0) {
                chatHistory.forEach(msg => {
                    if (msg.role === 'assistant') appendBotMsg(msg.content, false, false);
                    else if (msg.role === 'user') appendUserMsg(msg.content, false);
                });
            }
            // sincronizează înapoi localStorage (în caz că era >15)
            saveHistory();
        } else {
            localStorage.removeItem(chatKey);
        }
    } catch (e) {
        console.error("Nu s-a putut restaura istoricul:", e);
        localStorage.removeItem(chatKey);
    }
}

// =================================================================================
// AFIȘARE MESAJE ȘI CARDURI
// =================================================================================

function appendUserMsg(msg, save = true) {
    const chatContent = document.getElementById('ai-chat-content');
    if (!chatContent) return;
    const div = document.createElement('div');
    div.className = 'ai-msg ai-user ai-msg-appear';
    div.innerHTML = htmlEntities(msg);
    chatContent.appendChild(div);
    if (save) chatHistory.push({
        role: 'user',
        content: msg
    });
    if (save) saveHistory();
    scrollChatDown();
}

/**
 * Adaugă un mesaj de la bot în chat, cu sau fără animație.
 * @param {string} msg Mesajul de afișat.
 * @param {boolean} save Salvează mesajul în istoric?
 * @param {boolean} animated Afișează mesajul cu efect de scriere?
 */
function appendBotMsg(msg, save = true, animated = true) {
    const chatContent = document.getElementById('ai-chat-content');
    if (!chatContent) return;

    // Regex pentru a detecta cardurile de produs
    const cardRegex = /\[PRODUCT_CARD:([^\]]+)\]/g;
    const parts = msg.split(cardRegex);

    let currentIndex = 0;
    const processNextPart = () => {
        if (currentIndex >= parts.length) {
            // Am terminat de procesat mesajul
            if (save) {
                chatHistory.push({
                    role: 'assistant',
                    content: msg
                });
                saveHistory();
            }
            scrollChatDown();
            return;
        }

        const part = parts[currentIndex];
        const isProductHandle = (currentIndex % 2) === 1;

        if (isProductHandle) {
            // Este un handle de produs
            const handle = part;
            const product = products.find(p => p.handle === handle);
            if (product) {
                appendProductCard(product);
            }
            currentIndex++;
            processNextPart(); // Trece la următorul element
        } else {
            // Este un text normal
            const textContent = part.trim();
            if (textContent) {
                const textDiv = document.createElement('div');
                textDiv.className = 'ai-msg ai-bot';
                chatContent.appendChild(textDiv);
                
                // Animație de scriere doar pentru text, dacă este cerută
                if (animated) {
                    let i = 0;
                    const timer = setInterval(() => {
                        if (i < textContent.length) {
                            textDiv.innerHTML += htmlEntities(textContent.charAt(i));
                            scrollChatDown();
                            i++;
                        } else {
                            clearInterval(timer);
                            textDiv.classList.add('ai-msg-appear');
                            currentIndex++;
                            processNextPart(); // Continuă procesarea
                        }
                    }, 10); // Viteză de scriere (10ms/caracter)
                } else {
                    // Mesaj instant, fără animație (pentru istoric)
                    textDiv.innerHTML = formatLinks(textContent).replace(/\n/g, '<br>');
                    textDiv.classList.add('ai-msg-appear');
                    currentIndex++;
                    processNextPart();
                }
            } else {
                 // Partea de text este goală, trecem la următorul element
                currentIndex++;
                processNextPart();
            }
        }
    };

    processNextPart();
}


function appendProductCard(product) {
    const chatContent = document.getElementById('ai-chat-content');
    if (!chatContent || !product) return;

    const card = document.createElement('a'); // întregul card e link
    card.className = 'ai-product-card-interactive';
    card.setAttribute('data-handle', product.handle);
    card.href = product.url;
    card.target = '_blank';
    card.rel = 'noopener noreferrer';

    const formattedPrice = `${product.price.toFixed(2).replace('.', ',')} lei`;

    card.innerHTML = `
        <div class="ai-product-card-interactive-img-wrapper">
            <div class="ai-product-card-interactive-image-container">
                <img src="${safeAbs(product.image)}" alt="${htmlEntities(product.title)}"
                    class="ai-product-card-interactive-image"
                    onerror="this.src='https://placehold.co/80x80/121212/E0F7FA?text=Imagine'; this.onerror=null;">
            </div>
            <button class="ai-add-to-cart-btn" onclick="event.preventDefault(); addToCart(${product.variant_id}, '${htmlEntities(product.title)}');">🛒 Adauga</button>
        </div>
        <div class="ai-product-card-interactive-content">
            <div class="ai-product-card-interactive-title">${htmlEntities(product.title)}</div>
            <div class="ai-product-card-interactive-price">${formattedPrice}</div>
            <div class="ai-product-card-interactive-description">${htmlEntities(product.description)}</div>
        </div>
    `;

    chatContent.appendChild(card);
    scrollChatDown();
}

function appendTyping() {
    if (document.getElementById('ai-bot-typing')) return;
    const chat = document.getElementById('ai-chat-content');
    const typing = document.createElement('div');
    typing.id = 'ai-bot-typing';
    typing.className = 'ai-msg ai-bot ai-bot-typing';
    typing.innerHTML = '<span></span><span></span><span></span>';
    chat.appendChild(typing);
    scrollChatDown();
}

function removeTyping() {
    const el = document.getElementById('ai-bot-typing');
    if (el) el.remove();
}

// =================================================================================
// LOGICA PRINCIPALĂ (TRIMITERE MESAJE, APEL API)
// =================================================================================

async function loadProducts() {
    try {
        // 1) Citește cache-ul local
        const cachedRaw = localStorage.getItem(PRODUCTS_CACHE_KEY);
        const cached = cachedRaw ? JSON.parse(cachedRaw) : null;
        const isFresh = cached && (Date.now() - cached.ts) < PRODUCTS_TTL_MS;

        // 2) Dacă e proaspăt, încarcă în memorie și gata
        if (isFresh && Array.isArray(cached.products) && cached.products.length) {
            products = cached.products;
            console.log("Produsele din cache (client):", products.length);
            return;
        }

        // 3) Fă cererea către endpoint cu If-None-Match (dacă avem etag)
        const headers = {};
        if (cached?.etag) headers['If-None-Match'] = cached.etag;

        const res = await fetch(productsEndpoint, {
            credentials: 'include',
            headers
        });

        // 304 → folosește cache-ul
        if (res.status === 304 && cached?.products?.length) {
            products = cached.products;
            console.log("Produsele (304, ETag) din cache:", products.length);
            return;
        }

        if (!res.ok) throw new Error(`Failed to fetch products: ${res.status}`);
        const json = await res.json();
        if (!json?.ok) throw new Error(`API responded ok=false: ${json?.error || 'unknown error'}`);

        // 4) Normalizează produse pentru chat
        const arr = Array.isArray(json.products) ? json.products : [];
        products = arr.map(p => {
            const priceNum = typeof p.price === 'number' ? p.price : Number(p.price || 0);
            const numericVariantId = p.variant_id ? extractNumericId(p.variant_id) : null;
            const img = p.image ? (p.image.startsWith('http') ? p.image : `https:${p.image}`) : null;

            return {
                ...p,
                url: `${siteUrl}/products/${p.handle}`,
                description: (window.TOMGO?.stripHtml ? TOMGO.stripHtml(p.description) : String(p.description || '')),
                image: img,
                price: priceNum,
                variant_id: numericVariantId,
                metafields: {
                    pentru: p.metafields?.pentru || [],
                    ocazie: p.metafields?.ocazie || []
                }
            };
        });

        // 5) Salvează în cache cu noul ETag
        const etag = res.headers.get('ETag') || json.etag || null;
        localStorage.setItem(PRODUCTS_CACHE_KEY, JSON.stringify({
            etag,
            ts: Date.now(),
            products
        }));

        console.log("Produsele (fresh din server):", products.length);
    } catch (e) {
        console.error("Nu s-au putut încărca produsele:", e);

        // fallback: dacă avem ceva în cache vechi, măcar îl folosim
        const cachedRaw = localStorage.getItem(PRODUCTS_CACHE_KEY);
        const cached = cachedRaw ? JSON.parse(cachedRaw) : null;
        if (cached?.products?.length) {
            products = cached.products;
            console.log("Fallback la cache local:", products.length);
        } else {
            products = [];
        }
    }
}

async function getCart() {
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch cart');
        currentCart = await response.json();
        console.log("Cart context updated:", currentCart);
    } catch (error) {
        console.error("Could not get cart context:", error);
        currentCart = null;
    }
}

function extractNumericId(gid) {
    // ex: gid://shopify/ProductVariant/55573663580540  => 55573663580540
    const m = String(gid).match(/\/(\d+)$|^(\d+)$/);
    return m ? Number(m[1] || m[2]) : null;
}

async function addToCart(variantId, productName) {
    try {
        const idNum = typeof variantId === 'number' ? variantId : extractNumericId(variantId);
        if (!idNum) throw new Error('ID variantă invalid (nu e numeric).');

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: idNum,
                    quantity: 1
                }]
            })
        });

        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err?.description || `Eroare la /cart/add.js (${response.status})`);
        }

        const cartContent = document.getElementById('ai-chat-content');
        const notification = document.createElement('div');
        notification.className = 'ai-msg ai-cart-notification';
        notification.textContent = `✨ "${productName}" a fost adăugat în coș!`;
        cartContent.appendChild(notification);
        scrollChatDown();

        // actualizează contextul coșului
        await getCart();
        document.body.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: currentCart
        }));
    } catch (error) {
        console.error('Eroare la adăugarea în coș:', error);
        appendBotMsg(`😕 Oops! A apărut o eroare la adăugarea produsului în coș: ${error.message}`);
    }
}

function handleProactiveTriggers() {
    const path = window.location.pathname;
    if (isParked()) return; // respectă blocarea auto-open
    if (path.includes('/products/')) {
        const handle = path.split('/products/')[1].split('?')[0];
        const product = products.find(p => p.handle === handle);
        if (product) {
            console.log(`Proactive Trigger: User is viewing product "${product.title}"`);
                const proactiveMessage = `Am remarcat interesul dumneavoastră pentru ${product.title}. Este o alegere deosebită! Vă pot ajuta să generați mesaje personalizate unice pentru acest produs, astfel încât cadoul să fie cu adevărat perfect. Spuneți-mi ce tip de mesaj doriți să creez pentru dumneavoastră. 😊`;            setTimeout(() => {
                const chatbox = document.getElementById('ai-chatbox');
                if (!chatbox.classList.contains('is-open') && !sessionStorage.getItem(`proactive_opened_${handle}`)) {
                    openChat(false, proactiveMessage);
                    sessionStorage.setItem(`proactive_opened_${handle}`, 'true');
                }
            }, 25000);
        }
    }
}

async function sendMessage() {
    clearTimeout(autoOpenTimer);
    const input = document.getElementById('ai-chat-input');
    const userMsg = input.value.trim();
    if (!userMsg) return;

    if (!proxyEndpoint && !openaiApiKey) {
        appendBotMsg("Se pare că asistentul AI nu este configurat corect. Te rugăm să contactezi administratorul site-ului.");
        return;
    }

    appendUserMsg(userMsg);
    input.value = '';
    appendTyping();

    try {
        const aiResponse = await askAi(chatHistory);
        removeTyping();
        const responseText = aiResponse || "Îmi pare rău, am întâmpinat o eroare. Te rog, încearcă din nou.";
        appendBotMsg(responseText, true, true); // Folosim animație pentru răspunsul la mesajul userului
    } catch (error) {
        console.error("Eroare la trimiterea mesajului:", error);
        removeTyping();
        appendBotMsg("Am întâmpinat o eroare. Te rog, încearcă din nou.", true, true);
    }
}

async function askAi(history) {
    const productDataForAI = products.length > 0 ?
        products.map(p =>
            `Handle: ${p.handle}\nTitlu: ${p.title}\nDescriere: ${p.description}\nRecomandat Pentru: ${p.metafields?.pentru?.join(', ') || 'N/A'}\nOcazie: ${p.metafields?.ocazie?.join(', ') || 'N/A'}`
        ).join('\n---\n') :
        "Niciun produs nu a fost încărcat.";

    const cartContextForAI = currentCart && currentCart.item_count > 0 ?
        `Clientul are deja următoarele produse în coș:\n${currentCart.items.map(item => `- ${item.product_title} (Cantitate: ${item.quantity})`).join('\n')}\nSubtotal coș: ${(currentCart.total_price / 100).toFixed(2)} lei.` :
        "Coșul clientului este gol.";

    const systemPrompt = `
# Rol: Ești TOM, Concierge-ul de Cadouri de la TOM GO
Misiunea ta este să creezi o experiență de 5 stele, personalizată și memorabilă pentru fiecare client. Nu ești un robot, ci un prieten expert în cadouri, care face clientul să se simtă special, ascultat și ghidat. Scopul final: clientul găsește cadoul perfect și finalizează comanda cu entuziasm.

## Personalitatea ta:
- **Empatic și Călduros:** Ton prietenos, cald, încurajator, care inspiră încredere.
- **Curios și Proactiv:** Pune întrebări relevante pentru a înțelege nevoile clientului rapid.
- **Expert și Pasional:** Prezintă produsele cu entuziasm, evidențiind emoția pe care o vor genera.
- **Elegant și Jucăuș:** Folosește emoji-uri discrete (🎁, ✨, 😊, ❤️) pentru a adăuga personalitate.
- Poti sa introduci si glume ca clientul sa se simta bine. Sa ii atragi antentia ca nu esti un robot, sa para ca esti o persoana reala
- nu ai voie sa fii folosit inafara site-ului. raspunzi la produse de personalizare, cadouri, obiecte decorative. nu ai voie sa fii folosit in alte scopuri decat pentru site-ul tomgo.ro
- Produsele care au personalizare-text se pot personaliza doar cu text dar la cerinta clientului putem adauga si o altfel de personalizare
- Produsele care au personalizare-poza se pot personaliza doar cu poza dar la cerinta clientului putem adauga si o altfel de personalizare
- Produsele care au personalizare-poza si personalizare-text se pot personaliza si cu poza si cu text dar la cerinta clientului putem adauga si o altfel de personalizare


## Contextul Clientului:
${cartContextForAI}
**Notă:** Livrare gratuită pentru comenzi peste 100 lei.

## Reguli de Aur (OBLIGATORII):
1. **Protocol de Conversație:**

    - **Analizeaza ce a selectat clientul din funnel pentru a înțelege contextul.
    - **Recomandare:** Propune 2-3 produse relevante, bazate pe contextul clientului și datele disponibile. 
    - **RECOMANDA DOAR PRODUSE DIN SITE. Nu ai voie sa recomanzi altceva. Daca nu ai ceva potrivit iti ceri scuze si specifici ca nu ai ceva potrivit pentru cerintele clientului insa avem altceva daca il intereseaza.
    - **Prezentare Specială:** Pentru fiecare produs, folosește formatul \`[PRODUCT_CARD:handle-ul-produsului]\`. Obligatoriu.
    - **Argumentare:** Explică pe scurt de ce ai ales fiecare produs, conectând emoțional recomandarea la nevoile clientului.
    - **Call-to-Action:** Încheie cu o întrebare deschisă (ex: „Ce crezi despre aceste idei?”) pentru a încuraja dialogul.

2. **Utilizarea Datelor:**
    - Bazează recomandările pe câmpurile „Recomandat Pentru” și „Ocazie” din datele produselor.
    - Prioritizează produsele care se potrivesc cel mai bine cu contextul clientului.

3. **Gestionarea Coșului:**
    - **Coș nevid:** Recunoaște produsele din coș și evită să le recomanzi din nou.
    - **Aproape de livrare gratuită:** Dacă subtotalul este aproape de 100 lei (ex: 70-99 lei), sugerează subtil un produs mic (ex: Tablou Abstract) pentru a atinge pragul de livrare gratuită.
    - **Upsell/Cross-sell:** Propune produse complementare (ex: o ramă foto pentru un tablou, o felicitare pentru un cadou).

4. **Formatul Recomandărilor:**
    - Folosește EXCLUSIV formatul \`[PRODUCT_CARD:handle-ul-produsului]\` pentru recomandări.
    - Nu folosi linkuri standard de tipul \`[Nume](link)\`.

## Lista de Produse Disponibile:
${productDataForAI}

## Informații Administrative:
- **Transport:** 25 lei (gratuit pentru comenzi peste 100 lei).
- **Contact:** WhatsApp 0750 499 535 pentru suport rapid.

## Optimizări pentru Performanță:
- **Răspunsuri Concise:** Formulează răspunsuri clare, evitând detaliile inutile, dar păstrând tonul cald și personal.
- **Prioritizare Inteligentă:** Alege produsele cu cel mai mare impact emoțional pentru client, bazându-te pe context.
- **Flexibilitate:** Dacă clientul oferă informații limitate, sugerează cadouri versatile și populare, adaptate ocaziei.
- **Proactivitate:** Anticipă nevoile clientului (ex: „Dacă e o ocazie romantică, poate dorești și o felicitare personalizată?”).
`;

    const payload = {
        model: 'gpt-4o',
        messages: [{
            role: 'system',
            content: systemPrompt
        }, ...history.slice(-4)],
        max_tokens: 600,
        temperature: 0.8
    };

    try {
        const res = await fetch(proxyEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!res.ok) throw new Error(`API error: ${(await res.json()).error.message}`);
        const data = await res.json();
        return data.choices?.[0]?.message.content.trim() || '';
    } catch (e) {
        console.error("Eroare OpenAI:", e);
        return null;
    }
}